import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { InsurerStrip } from "@/components/site/InsurerStrip";
import { MachineShowcase } from "@/components/site/MachineShowcase";
import { BestOffer } from "@/components/site/BestOffer";
import { Included } from "@/components/site/Included";
import { Testimonials } from "@/components/site/Testimonials";
import { Claims } from "@/components/site/Claims";
import { Faq } from "@/components/site/Faq";
import { Footer } from "@/components/site/Footer";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";
import { StickyMobileCTA } from "@/components/site/StickyMobileCTA";

export default function Landing() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <InsurerStrip />
        <MachineShowcase />
        <BestOffer />
        <Included />
        <Testimonials />
        <Claims />
        <Faq />
      </main>
      <Footer />
      <WhatsAppButton />
      <StickyMobileCTA />
    </div>
  );
}
